import React, { useEffect, useState } from 'react';
import MyWorklist from './MyWorklist';
import ApprovedProperties from './ApprovedProperties';
import Navbar from '../NavBar/Navbar';
import './VerifyAlert.css';
import FadeLoader from "react-spinners/FadeLoader";

const ReviewTab = () => {
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const [activeTab, setActiveTab] = useState('tab1');
    const [tabOneCount, setTabOneCount] = useState(0);
    const [tabTwoCount, setTabTwoCount] = useState(0);
    const [isEdit, setEdit] = useState(false);
    const [loader, setLoader] = useState(false);
    const [mapvisible, setMapvisible] = useState(false);
    const [checkReviewTab, setCheckReviewTab] = useState(false);
    const [unauthorizedAccess, setUnauthorizedAccess] = useState(false);
    const [parkingLotBookingDetails, setParkingLotBookingDetails] = useState([]);
    const [tab1Loaded, setTab1Loaded] = useState(false);

    const handleEdit = (val) => {
        setEdit(val);
        setCheckReviewTab(val);
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (tab === 'tab1' && !tab1Loaded) {
            fetchActiveProperties();
        }
    };
    const handleMapvisible = (val) => {
        setMapvisible(val);
    };

    const handlePendingCount = (val) => {
        setTabTwoCount(val); // Note: pending review count is now tab2
    };

    const fetchActiveProperties = async () => {
        setLoader(true);
        try {
            const response = await fetch(`${hostPath}/api/GetAllParkingLots?status=Active`, {
                method: 'GET',
                headers: { "x-functions-key": `${hostHeader}` },
            });
            if (!response.ok) {
                if (response.status === 401) {
                    setUnauthorizedAccess(true);
                    throw new Error('Unauthorized');
                } else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            }
            const data = await response.json();
            setTabOneCount(data.length); // Active property count
            const mergedData = data.map(({ pl, ...rest }) => ({
                ...rest,
                ...pl,
            }));
            setParkingLotBookingDetails(mergedData);
            setTab1Loaded(true);
        } catch (error) {
            console.error('Failed to fetch active properties:', error);
        } finally {
            setLoader(false);
        }
    };

    // ✅ Fetch active properties on first load
    useEffect(() => {
        if (!tab1Loaded) {
            fetchActiveProperties();
        }
    }, []);

    return (
        <div>
             {unauthorizedAccess ? (  // Check authorization
                <div className="unauthorized-container">
                    <h2>Unauthorized Access</h2>
                    <p>You do not have permission to view this page.</p>
                </div>
            ) : (
                <>
                    <Navbar mapvisible={mapvisible} setMapvisible={handleMapvisible} />

                    {!isEdit && (
                        <div className="tab-titles">
                            <button
                                className={activeTab === 'tab1' ? 'active' : ''}
                                onClick={() => handleTabChange('tab1')}
                            >
                                Active Properties <span className={`tab-count ${activeTab === 'tab1' ? 'active-count' : ''}`}>{tabOneCount}</span>
                            </button>
                            <button
                                className={activeTab === 'tab2' ? 'active' : ''}
                                onClick={() => handleTabChange('tab2')}
                            >
                                Pending Review <span className={`tab-count ${activeTab === 'tab2' ? 'active-count' : ''}`}>{tabTwoCount}</span>
                            </button>
                        </div>
                    )}

                    <div className="tab-content-container">
                        {/* {activeTab === 'tab1' && (
                            <ApprovedProperties parkingLotBookingDetails={parkingLotBookingDetails} />
                        )}
                        {activeTab === 'tab2' && (
                            <MyWorklist
                                handlePendingCount={handlePendingCount}
                                handleEdit={handleEdit}
                                isEdit={isEdit}
                                mapVisibleChangesAlert={handleMapvisible}
                                checkReviewTab={checkReviewTab}
                            />
                        )} */}

                        <div style={{ display: activeTab === 'tab1' ? 'block' : 'none' }}>
                            <ApprovedProperties parkingLotBookingDetails={parkingLotBookingDetails} />
                        </div>
                        <div style={{ display: activeTab === 'tab2' ? 'block' : 'none' }}>
                            <MyWorklist
                                handlePendingCount={handlePendingCount}
                                handleEdit={handleEdit}
                                isEdit={isEdit}
                                mapVisibleChangesAlert={handleMapvisible}
                                checkReviewTab={checkReviewTab}
                            />
                        </div>
                    </div>

                    {loader && (
                        <div className="loader-overlay">
                            <FadeLoader />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ReviewTab;
